<template>
  <div>
    <client-info
      @input="send"
      :id="order['client']['id']"
      button_key="next_step"
    />
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";
import ClientInfo from "@/components/Partners/ClientInfo";
export default {
  components: {
    Cards: () => import("@/components/Item/Order/Client/Cards"),
    ClientInfo,
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  async created() {},
  methods: {
    // async changeCard(val) {
    //   await this.updateOrder({ card_id: val });
    // },
    send(val) {
      console.log(val);

      try {
        if (!val.passport_number) {
          this.$notify({
            title: `!!!`,
            message: "Введите номер паспорта",
            icon: "ti-close",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
          return false;
        }
        if (!val.PINFL) {
          this.$notify({
            title: `!!!`,
            message: "Введите ПИНФЛ",
            icon: "ti-close",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
          return false;
        }
        if (!val.passport_1) {
          this.$notify({
            title: `!!!`,
            message: "Загрузите фото паспорта или ID",
            icon: "ti-close",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
          return false;
        }
        if (!val.passport_3) {
          this.$notify({
            title: `!!!`,
            message: "Загрузите прописку или обратную сторону ID",
            icon: "ti-close",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
          return false;
        }
        if (!val.passport_4) {
          this.$notify({
            title: `!!!`,
            message: "Загрузите селфи с документом",
            icon: "ti-close",
            horizontalAlign: "right",
            verticalAlign: "top",
          });

          return false;
        }
      } catch (error) {}

      logger(this.$http, {
        name: `Установлены данные клиента`,
        description: "",
        model_type: "order",
        model_id: this.order.id,
      });

      this.$emit("setStep", "add_card");
    },
  },
  data() {
    return {};
  },
};
</script>

